import { render, staticRenderFns } from "./UltimasNovedadesTab.vue?vue&type=template&id=af20a73c"
import script from "./UltimasNovedadesTab.vue?vue&type=script&lang=js"
export * from "./UltimasNovedadesTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports